import { render } from "./headerDevis.vue?vue&type=template&id=573f07dd&scoped=true"
import script from "./headerDevis.vue?vue&type=script&lang=js"
export * from "./headerDevis.vue?vue&type=script&lang=js"

import "./headerDevis.vue?vue&type=style&index=0&id=573f07dd&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573f07dd"]])

export default __exports__